<template>
  <v-container fluid>
    <v-card-title>System Settings Dispatch</v-card-title>
    <v-card-text>
      <p class="text-subtitle-2 mb-1">Summer Week</p>
      <v-card class="d-flex" flat>
        <InputDate v-model="summer" label="From" dense class="pr-2"></InputDate>
        <v-text-field label="To" v-model="summerEnd" readonly class="pl-2"></v-text-field>
      </v-card>
      <p class="text-subtitle-2 mb-1">Winter Week</p>
      <v-card class="d-flex" flat>
        <InputDate v-model="winter" label="From" dense class="pr-2"></InputDate>
        <v-text-field label="To" v-model="winterEnd" readonly class="pl-2"></v-text-field>
      </v-card>
    </v-card-text>
  </v-container>
</template>

<script>
import { DateTime } from "luxon";

export default {
  name: "SettingsSystemDispatch",
  components: {
    InputDate: () => import("@/components/InputDate.vue"),
  },
  mixins: [],
  props: {
    value: { type: Object, required: false, default: () => ({}) },
  },
  data() {
    return {};
  },
  computed: {
    summer: {
      get() {
        return this.value.summerWeek;
      },
      set(v) {
        const valueCopy = this.value;
        valueCopy.summerWeek = v;
        this.$emit("input", valueCopy);
      },
    },
    winter: {
      get() {
        return this.value.winterWeek;
      },
      set(v) {
        const valueCopy = this.value;
        valueCopy.winterWeek = v;
        this.$emit("input", valueCopy);
      },
    },
    summerEnd() {
      return DateTime.fromISO(this.summer).plus({ days: 6 }).toISODate();
    },
    winterEnd() {
      return DateTime.fromISO(this.winter).plus({ days: 6 }).toISODate();
    },
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {},
};
</script>

<style></style>
